// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */

import { Customization } from '@/common/types/student';
import Customizations from '@/game/GameComponents/GameData/customizations.json';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getCharacterInventory } from '@/game/GameComponents/PhaserGame/GameInstance';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap.ts';
const customizations = Customizations as Customization[];
/* END-USER-IMPORTS */

export default class ComplexionSelection extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // complexionOption
    const complexionOption = scene.add.container(0, 0);
    complexionOption.scaleX = 4;
    complexionOption.scaleY = 4;
    this.add(complexionOption);

    // complexionChoiceFrame_1
    const complexionChoiceFrame_1 = scene.add.image(0, 0, 'blank-circle-frame');
    complexionOption.add(complexionChoiceFrame_1);

    // complexionChoiceButton
    const complexionChoiceButton = scene.add.image(0, 0, 'blank-circle');
    complexionChoiceButton.tintTopLeft = 14400922;
    complexionChoiceButton.tintTopRight = 14400922;
    complexionChoiceButton.tintBottomLeft = 14400922;
    complexionChoiceButton.tintBottomRight = 14400922;
    complexionOption.add(complexionChoiceButton);

    // complexionOption_1
    const complexionOption_1 = scene.add.container(60, 0);
    complexionOption_1.scaleX = 4;
    complexionOption_1.scaleY = 4;
    this.add(complexionOption_1);

    // complexionChoiceFrame_2
    const complexionChoiceFrame_2 = scene.add.image(0, 0, 'blank-circle-frame');
    complexionOption_1.add(complexionChoiceFrame_2);

    // complexionChoiceButton_1
    const complexionChoiceButton_1 = scene.add.image(0, 0, 'blank-circle');
    complexionChoiceButton_1.tintTopLeft = 13146761;
    complexionChoiceButton_1.tintTopRight = 13146761;
    complexionChoiceButton_1.tintBottomLeft = 13146761;
    complexionChoiceButton_1.tintBottomRight = 13146761;
    complexionOption_1.add(complexionChoiceButton_1);

    // complexionOption_2
    const complexionOption_2 = scene.add.container(120, 0);
    complexionOption_2.scaleX = 4;
    complexionOption_2.scaleY = 4;
    this.add(complexionOption_2);

    // complexionChoiceFrame_4
    const complexionChoiceFrame_4 = scene.add.image(0, 0, 'blank-circle-frame');
    complexionOption_2.add(complexionChoiceFrame_4);

    // complexionChoiceButton_2
    const complexionChoiceButton_2 = scene.add.image(0, 0, 'blank-circle');
    complexionChoiceButton_2.tintTopLeft = 15579516;
    complexionChoiceButton_2.tintTopRight = 15579516;
    complexionChoiceButton_2.tintBottomLeft = 15579516;
    complexionChoiceButton_2.tintBottomRight = 15579516;
    complexionOption_2.add(complexionChoiceButton_2);

    // complexionOption_3
    const complexionOption_3 = scene.add.container(30, 20);
    complexionOption_3.scaleX = 4;
    complexionOption_3.scaleY = 4;
    this.add(complexionOption_3);

    // complexionChoiceFrame_6
    const complexionChoiceFrame_6 = scene.add.image(0, 0, 'blank-circle-frame');
    complexionOption_3.add(complexionChoiceFrame_6);

    // complexionChoiceButton_3
    const complexionChoiceButton_3 = scene.add.image(0, 0, 'blank-circle');
    complexionChoiceButton_3.tintTopLeft = 12550743;
    complexionChoiceButton_3.tintTopRight = 12550743;
    complexionChoiceButton_3.tintBottomLeft = 12550743;
    complexionChoiceButton_3.tintBottomRight = 12550743;
    complexionOption_3.add(complexionChoiceButton_3);

    // complexionOption_4
    const complexionOption_4 = scene.add.container(90, 20);
    complexionOption_4.scaleX = 4;
    complexionOption_4.scaleY = 4;
    this.add(complexionOption_4);

    // complexionChoiceFrame_8
    const complexionChoiceFrame_8 = scene.add.image(0, 0, 'blank-circle-frame');
    complexionOption_4.add(complexionChoiceFrame_8);

    // complexionChoiceButton_4
    const complexionChoiceButton_4 = scene.add.image(0, 0, 'blank-circle');
    complexionChoiceButton_4.tintTopLeft = 8403489;
    complexionChoiceButton_4.tintTopRight = 8403489;
    complexionChoiceButton_4.tintBottomLeft = 8403489;
    complexionChoiceButton_4.tintBottomRight = 8403489;
    complexionOption_4.add(complexionChoiceButton_4);

    this.complexionChoiceFrame_1 = complexionChoiceFrame_1;
    this.complexionChoiceButton = complexionChoiceButton;
    this.complexionOption = complexionOption;
    this.complexionChoiceFrame_2 = complexionChoiceFrame_2;
    this.complexionChoiceButton_1 = complexionChoiceButton_1;
    this.complexionOption_1 = complexionOption_1;
    this.complexionChoiceFrame_4 = complexionChoiceFrame_4;
    this.complexionChoiceButton_2 = complexionChoiceButton_2;
    this.complexionOption_2 = complexionOption_2;
    this.complexionChoiceFrame_6 = complexionChoiceFrame_6;
    this.complexionChoiceButton_3 = complexionChoiceButton_3;
    this.complexionOption_3 = complexionOption_3;
    this.complexionChoiceFrame_8 = complexionChoiceFrame_8;
    this.complexionChoiceButton_4 = complexionChoiceButton_4;
    this.complexionOption_4 = complexionOption_4;

    /* START-USER-CTR-CODE */
    this.create();
    /* END-USER-CTR-CODE */
  }

  private complexionChoiceFrame_1: Phaser.GameObjects.Image;
  private complexionChoiceButton: Phaser.GameObjects.Image;
  private complexionOption: Phaser.GameObjects.Container;
  private complexionChoiceFrame_2: Phaser.GameObjects.Image;
  private complexionChoiceButton_1: Phaser.GameObjects.Image;
  private complexionOption_1: Phaser.GameObjects.Container;
  private complexionChoiceFrame_4: Phaser.GameObjects.Image;
  private complexionChoiceButton_2: Phaser.GameObjects.Image;
  private complexionOption_2: Phaser.GameObjects.Container;
  private complexionChoiceFrame_6: Phaser.GameObjects.Image;
  private complexionChoiceButton_3: Phaser.GameObjects.Image;
  private complexionOption_3: Phaser.GameObjects.Container;
  private complexionChoiceFrame_8: Phaser.GameObjects.Image;
  private complexionChoiceButton_4: Phaser.GameObjects.Image;
  private complexionOption_4: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  public onComplexionSelected?: (complexionId: number) => void;
  complexionOptions: ComplexionOption[] = [];
  jointPicker?: ComplexionSelection;

  create() {
    this.complexionOptions = [
      {
        container: this.complexionOption,
        button: this.complexionChoiceButton,
        frame: this.complexionChoiceFrame_1,
        complexionId: 95,
      },
      {
        container: this.complexionOption_1,
        button: this.complexionChoiceButton_1,
        frame: this.complexionChoiceFrame_2,
        complexionId: 96,
      },
      {
        container: this.complexionOption_2,
        button: this.complexionChoiceButton_2,
        frame: this.complexionChoiceFrame_4,
        complexionId: 97,
      },
      {
        container: this.complexionOption_3,
        button: this.complexionChoiceButton_3,
        frame: this.complexionChoiceFrame_6,
        complexionId: 98,
      },
      {
        container: this.complexionOption_4,
        button: this.complexionChoiceButton_4,
        frame: this.complexionChoiceFrame_8,
        complexionId: 99,
      },
    ];

    this.complexionOptions.forEach((option) => {
      option.button.setInteractive({ cursor: `${HOVER_CURSOR_PATH}` });
      option.button.on('pointerover', () => {
        option.container.setScale(4.4);
        PhaserAudioManager.playSFX(this.scene, 'hover-click');
      });
      option.button.on('pointerout', () => {
        option.container.setScale(4);
      });
      option.button.on('pointerdown', () => {
        this.handleComplexionSelected(option);
        PhaserAudioManager.playSFX(this.scene, 'submit-click');
      });
    });
  }

  setComplexionEquipped(
    complexionOption: ComplexionOption,
    isEquipped: boolean,
  ) {
    complexionOption.button.setTexture('blank-circle');
    complexionOption.frame.setTexture(
      isEquipped ? 'blank-circle-frame-selected' : 'blank-circle-frame',
    );
    complexionOption.container.setScale(isEquipped ? 4.4 : 4);
  }

  resetComplexionSelection() {
    // Visually select the option.
    const complexion = getCharacterInventory().equippedItems.complexion;
    this.complexionOptions.forEach((o) => {
      this.setComplexionEquipped(o, o.complexionId === complexion);
    });
  }

  conjoinWithPicker(picker: ComplexionSelection) {
    if (picker === this) return;
    this.jointPicker = picker;
    picker.jointPicker = this;
  }

  handleComplexionSelected(option: any) {
    // Visually select the option.
    const complexion = customizations.find(
      (c: Customization) => c.id === option.complexionId,
    );
    this.complexionOptions.forEach((o) => {
      this.setComplexionEquipped(o, o === option);
    });

    if (this.jointPicker !== undefined) {
      const targetSelection = this.jointPicker.complexionOptions.find(
        (o) => o.complexionId === option.complexionId,
      );
      this.jointPicker.complexionOptions.forEach((o) => {
        this.jointPicker?.setComplexionEquipped(o, o === targetSelection);
      });
    }

    // If a callback is set, call it.
    if (this.onComplexionSelected) {
      this.onComplexionSelected(option);
      return;
    }

    // Otherwise, run default behaviour.
    if (complexion) {
      EventBus.emit(GAME_EVENTS.PLAYER_EQUIPPED_COSMETIC, complexion);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

export interface ComplexionOption {
  button: Phaser.GameObjects.Image;
  frame: Phaser.GameObjects.Image;
  container: Phaser.GameObjects.Container;
  complexionId: number;
}
